import * as React from "react"
import BergerLevraultConnector from "./berger-levrault-connector"
import * as Model from "../../../../model"
import * as ConnectorDomain from "../../../../domain/sfp/connector-domain"

const BergerLevraultConnectorComponent = BergerLevraultConnector as any as React.ComponentType<{
	loading: boolean;
	settings: Model.BergerLevrault;
	onChange(settings: ConnectorDomain.ConnectorSettings | null): void;
}>

export default class ConnectorField extends React.Component<Props> {
	render() {
		const connector = this.getConnector()

		return <div>
			<div className="field">
				<label className="label">Connecteur</label>

				<span className="field">
					<span className="control">
						<label className="radio">
							<input
							checked={connector === null}
							disabled={this.props.loading}
							type="radio"
							value={""}
							onChange={e => this.handleChange(e)}/>
							&nbsp;Pas de connecteur
						</label>

						<label className="radio">
							<input
							checked={connector === Connector.BergerLevrault}
							disabled={this.props.loading}
							type="radio"
							value={Connector.BergerLevrault}
							onChange={e => this.handleChange(e)}/>
							&nbsp;Berger Levrault
						</label>
					</span>
				</span>
			</div>

			{this.renderConnector()}
		</div>
	}

	private getConnector() {
		if (!this.props.settings) return null

		if (ConnectorDomain.areBergerLevraultSettings(this.props.settings))
			return Connector.BergerLevrault

		return null
	}

	private handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
		const value = parseInt(e.target.value)

		switch (value) {
			case Connector.BergerLevrault: return this.props.onChange({
				axe: 1,
				budget: null,
				enabled: true,
				idAxe: null,
				idCollectiviteGF: null,
				localAuthority: null,
				port: null,
				server: null
			})
			default: return this.props.onChange(null)
		}
	}

	private renderConnector(): React.ReactNode {
		switch (this.getConnector()) {
			case Connector.BergerLevrault: return this.renderBergerLevraultConnector()
			default: return null
		}
	}

	private renderBergerLevraultConnector(): React.ReactNode {
		return <BergerLevraultConnectorComponent
		loading={this.props.loading}
		settings={this.props.settings as Model.BergerLevrault}
		onChange={settings => this.props.onChange(settings)} />
	}
}

export enum Connector {
	BergerLevrault
}

interface Props {
	loading: boolean;
	settings: ConnectorDomain.ConnectorSettings | null;
	onChange(settings: ConnectorDomain.ConnectorSettings | null): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/index.tsx